import omit from 'lodash/omit'
import { action, computed, observable } from 'mobx'

export class FilterStore {
  @observable isLoading = false
  @observable validAttributes = false
  @observable filterAttributes = []
  @observable appliedFilters: any

  @computed get hasFilters() {
    for (let key in this.appliedFilters || {}) {
      if (this.appliedFilters[key]?.length) {
        return true
      }
    }
    return false
  }

  @computed get hasFilterAttributes() {
    for (let attribute of this.filterAttributes) {
      if (attribute?.values?.length) {
        return true
      }
    }
    return false
  }

  @action
  setAppliedFilters = (appliedFilters: any) => {
    this.appliedFilters = appliedFilters
  }

  @action
  clearAppliedFilters = () => {
    this.appliedFilters = []
  }

  @action
  setFilterAttributes = (attributes: any) => {
    this.filterAttributes = attributes
  }

  @action
  setIsValidAttributes = (isValidAttributes: boolean) => {
    this.validAttributes = isValidAttributes
  }

  @action
  removeFilterValue = (field, value) => {}

  @action
  removeFilterField = field => {
    this.appliedFilters = omit(this.appliedFilters, [field])
  }

  @action
  setLoading = (isLoading: boolean) => {
    this.isLoading = isLoading
  }

  @action
  reset = () => {
    this.isLoading = this.validAttributes = false
    this.filterAttributes = []
    this.appliedFilters = null
  }
}
